import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.js';
import { initTheme } from './lib/theme.js';

// Apply the stored/device theme and keep it in sync (light/dark). The inline
// no-flash snippet in index.html already set the initial data-theme before
// paint; this wires the runtime controller.
initTheme();

// Register the service worker that makes the dashboard installable. autoUpdate
// means a new deploy is picked up on the next load without a prompt.
registerSW({ immediate: true });

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
